<template>
    <div id="app">
        <v-app  v-model="show">          
           
            <v-card  class="pa-3 yellow lighten-3" dense>              
                    <v-row dense class="align-center">                      
                       <v-col cols="12" sm="2" md="1" >
                                <v-text-field 
                                dense 
                                 @keyup.enter="mostrarCabeceraOT(vOtrabajo)"  
                                 v-model="vOtrabajo"  
                                 ref="inputNP" 
                                 label="Nª OT"
                                 @input="limpiarTodo(1)"
                                ></v-text-field>  

                        </v-col>
                      
                        <v-col cols="auto"  >
                                 <v-btn dense x-small   @click="mostrarBuscadorOt()">
                                    ... 
                                </v-btn>   
                        </v-col>


                        <v-col  cols="12" sm="6" md="3"  >                                                                
                                <v-text-field dense class="text-md-center red--text"     disabled v-model="vDetalle"
                                   label="Nombre de Orden de Trabajo"                                                  
                                ></v-text-field>                    
                        </v-col> 

                        <v-col  cols="12" sm="6" md="2"  >
                            <v-text-field dense class="text-md-center red--text"     disabled v-model="vNota"
                                label="Nota"                                                   
                            ></v-text-field>                    
                        </v-col>            

                        <v-spacer></v-spacer>
                        
                        <v-col cols="auto" class="text-right">                                     
					            <v-btn class="mx-2" fab dark small @click="irMenuInge()"   color="black"  >
                                    		<v-icon>mdi-close</v-icon>
                                </v-btn>                                     
                        </v-col>
                    
                    </v-row>

            </v-card> 
            
            <v-card class="mb-3 pa-3 yellow lighten-5">
                    <v-row>
                        <v-col>
                            <v-data-table

                                    height="500"
                                    fixed-header
                                    dense
                                    :headers="headers"
                                    :items="desserts"    
                                    class="elevation-1"  
                                    item-key="iitem"
                                    :search="search"
                                
                                    :items-per-page.sync="itemsPerPage"
                                    :items-per-page-options="itemsPerPageOptions"    
                                    
                                >


                                <template v-slot:[`item.devuelto`]="{ item }" >

                                        <div class="right-input">
                                                <v-chip v-if="item.devuelto>0" color="yellow lighten-1"  v-model="item.devuelto"         
                                                    @click="activar(item)"
                                                    >
                                                    {{ item.devuelto }}
                                                </v-chip>      
                                        </div>


                                 </template>   
                                    
                                    <template v-slot:[`item.devuelta`]="{ item }">
                                        <v-text-field
                                            v-model="item.devuelta"
                                            type="number"
                                            dense
                                            hide-details
                                            solo
                                             @change="validarDevuelta(item)"
                                        />
                                    </template>
                                                 

                                    
                                    
                                </v-data-table> 

                        </v-col>
                    </v-row>
            </v-card>

            <v-card class="pa-3 yellow lighten-3"   dense >
                        
                   <v-row dense>
                        <v-col cols="12">

                            <v-textarea 
                                dense
                                v-model="vObserva"
                                label="Observación"
                                auto-grow
                                rows="1"
                                                                                                                                        
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                
            </v-card>

            <v-card class="pa-3 yellow lighten-3" dense>
                <v-row justify="center" align="center">

                  <v-col cols="auto" >                 
                    
                    <v-btn block dense color="primary" :disabled="vRegistrar" @click="registrarDevolucion()">
                        Registrar 
                    </v-btn>                   

                  </v-col>

                  

                  <v-col cols="auto" >                   
                 
                    <v-btn dense color="primary" @click="limpiarTodo(2)">
                        Limpiar
                    </v-btn>
                  </v-col>

                </v-row>

            </v-card>
                   
        </v-app>


        <BuscadorOT
            
                :visible="showCarga"
                :pnumot="this.numOT"
                :pnombreot="this.nombreOT"   
                :pflag="this.flag"            
                @close="showCarga = false"
                @otSel="vOtSel = $event"
                
            >
            
        </BuscadorOT>

        <v-dialog
                v-model="vDialogDevolucion"
                max-width="800px"
                persistent
            >
                
                <v-card>  

                    <v-card-title>
                        <v-row class="text-md-center red--text">
                            <!-- <v-col cols="12">
                              <h5>Resumen de Notas de Pedidos relacionado con la orden de trabajo</h5>  
                            </v-col> -->
                            <v-spacer></v-spacer>
                            <v-col cols="auto" class="text-right">                                     
					            <v-btn class="mx-2" fab dark small @click="vDialogDevolucion=false"   color="black"  >
                                    		<v-icon>mdi-close</v-icon>
                                </v-btn>                                     
                            </v-col>                           
                        </v-row>
                    </v-card-title>  
                    
                    <!-- <v-card-text>
                        
                                
                    </v-card-text> -->

                    <v-card-text>
                        <v-container>
                            
                            <v-data-table

                                   
                                    dense
                                    :headers="headersDevo"
                                    :items="dessertsDevo"
                                    class="elevation-1"  
                                    :items-per-page.sync="itemsPerPage"
                                    :items-per-page-options="itemsPerPageOptions" 
                                   
                                                               
                                                      
                            >

                                 
                               

                            </v-data-table>

                           

                        </v-container>
                    </v-card-text>

                   

                </v-card>
        </v-dialog>


        <v-dialog
                                              
                max-width="400"
                persistent
                
                v-model="registrando"
        >
                            
            <v-card>

                    <v-toolbar
                        color="primary"
                        dark
                    > Registro en proceso</v-toolbar>
                    <v-card-text>
                        <div class="text-h6 pa-2">Aguarde, se está guardando los datos..</div>
                    </v-card-text>
                                
            </v-card>
            
        </v-dialog>

    










    </div>
</template>

<script>

// import Axios from "../../../axios-auth-sistemas";


import Axios from "../../../axios-auth-sistemas";
import moment from "moment";
import  exportXlsFile from "export-from-json";
import jsPDF from "jspdf"; 
import "jspdf-autotable";

import BuscadorOT from "../EI026/BuscadorOT.vue";



export default {
    name:'FichaDevolcionMaterial',
    data(){
        return{        
           
            headers: 
                    [

                    {text: 'Item',value: 'item',  align: "center",sortable: false},
                    {text: 'Articulo',value: 'articulo' ,sortable: false },
                    {text: 'Detalle',value: 'detalle' ,sortable: false },
                    {text: 'Cant. Solicitada',value: 'cantidad',   sortable: true,align: 'left'},
                    {text: 'Cant. Devuelta',value: 'devuelto',   sortable: true,align: 'left'},

                    {text: 'A Devolver',value: 'devuelta',  align: "center",sortable: false }, 

                    ],
            headersDevo:[
                    {text: 'Fecha',value: 'fecha',  align: "center",sortable: false},
                    {text: 'Comprob',value: 'comprobante',  align: "center",sortable: false},                    
                    {text: 'Item',value: 'item',  align: "center",sortable: false},
                    {text: 'Articulo',value: 'articulo' ,sortable: false },
                    {text: 'Detalle',value: 'detalle' ,sortable: false },                    
                    {text: 'Cant. Devuelta',value: 'devuelto',   sortable: true,align: 'left'},                    
            ],                 
            desserts:[],
            dessertsDevo:[],
            search: '',
            showCarga: false,
            numOT:'',
            nombreOT:'',
            flag:'',
            vOtSel:'',

            vOtrabajo:'',
            vDetalle:'',
            vNota:'',
            vObserva:'',

            itemsPerPage: -1, // Configura itemsPerPage en -1 para mostrar todos los elementos por defecto
            itemsPerPageOptions: [-1,10, 25, 50,75,100,200],

            vNroComprobante:0,
            vRegistrar:false,

            vDialogDevolucion:false,


            registrando:false,



        }

    },

    computed:{

    },

    
    components: { 

        BuscadorOT,
        
    },


  
    watch: {

        vOtSel: function () {

            this.vOtrabajo= this.vOtSel;
         
            this.mostrarCabeceraOT(this.vOtSel)
        },


    },      

    computed: {    
      
        show: {
            get() {
               
                

              
            },
            set(value) {
                if (!value) {
                  
                }
            },
        },  

       
    },

    mounted() {
        this.$nextTick(() => {
            if (this.$refs.inputNP) {
                this.$refs.inputNP.focus();
            }
        });
    },  

    created(){
       
    },
    
   

    methods: { 
        limpiarTodo(id){               
               
                this.desserts=[];
                if (id == 2){
                    this.vOtrabajo="";
                    this.vRegistrar=false;
                    this.vNroComprobante=0;
                }
                this.vObserva="";
                this.vNota="";
                this.vDetalle="";               

          }, 

          mostrarCabeceraOT(id){
                   console.log("estoy en el metodo mostrarCabeceraOT ", this.vOtrabajo)
                console.log("estoy en el metodo mostrarCabeceraOT ", id)
                let self = this;                  
             
                Axios
                .get("/CtaOtPro/Getnombreot?", {
                params: {
                    id: id,
                },
                })
                .then((r) => {           
                    
                    
                    self.vOtrabajo = r.data[0].otrabajo
                    self.vDetalle = r.data[0].detalle  
                    self.vNota = r.data[0].nota1,              
                    self.mostrarDetalleOT(id);
                    
                       
                       
                })
                .catch((error) => {
                    // self.showAlert({
                    //         icon: "error",
                    //         title: "El Nº de orden de trabajo ingresado no existe",
                    //         vm: self,
                    //     });
                    self.$emit("close");
                    self.vOtrabajo="";
                    self.desserts=[];     
                                
                }); 
            },

            mostrarDetalleOT(id){

               
               
                let self = this; 
                self.desserts=[];
              
                           
                Axios               
                // .get("/SolicitudEI026/DetalleOT?", {
                .get("/Ti/GetMaterialDevolver?", {
                params: {
                    id: id,
                },
                })
                .then(r => {                 

                    console.log("datos bd", r.data)

                    if (r.data.length == 0){
                         this.$swal("","No existen datos para la orden de trabajo ingresada", "info")
                    }

                    r.data.forEach(element => {
                        self.desserts.push({

                            item: element.item,
                            articulo :element.estado == "1" ? element.articulo   :element.estado =="3" ? "Reempl." :element.estado =="5" ? "Anulado" :element.articulo,
                            detalle: element.detalle,
                            cantidad: element.cantidad,
                            devuelto: element.devuelto? element.devuelto.toString().replace(',', '.') : element.devuelto,
                            devuelta: "",
                            
                        })
                    });
                     
                  


                }).catch(r => {        
                     
                       this.$swal("","La orden de trabajo ingresada esta vacia", "info")
                });  
            },

            validarDevolucion() {
                let error = null;

                this.desserts.forEach(item => {

                    const solicitada = Number(item.cantidad || 0);
                    const devueltoAntes = Number(item.devuelto || 0);
                    const aDevolver = Number(item.devuelta || 0);

                    const maxPermitido = solicitada - devueltoAntes;
                 
                    if (aDevolver > maxPermitido) {
                    error = `El ítem ${item.item} (${item.articulo}) supera la cantidad permitida.
                    Máximo permitido: ${maxPermitido}`;
                        }
                    });

                    if (error) {
                        this.$swal({
                        icon: 'warning',
                        title: 'Cantidad inválida',
                        text: error
                        });
                        return false;
                    }

                    return true;
            },


            registrarDevolucion(){              

                if(this.vOtrabajo == '' )
                {

                        this.$swal({
                            title: "",
                            text: "Es obligatorio ingresar el número de orden de trabajo",
                            icon: "error"
                        });
                            
                        return;
                }
            
                const todosVacios = this.desserts.every(item => item.devuelta=='' || item.devuelta== 0);

                if (todosVacios) {
                        this.$swal({
                            title: "",
                            text: "No se cargo ningun item a devolver",
                            icon: "error"
                        });
                            
                        return;

                }

                if (!this.validarDevolucion()) {
                    return;
                }

                this.$swal({
                title: "",
                text: "¿Esta seguro de registrar una Devolución de Material?",
                icon: "success",
                background: "#ececec",
                showClass: {
                popup: "animate__animated animate__fadeInDown"
                },
                hideClass: {
                popup: "animate__animated animate__fadeOutUp"
                },
                showCancelButton: true,
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then(result => {
                    
                    if (result.value) 
                    {                             

                        let self = this;   
                        let vMatDev=[];                   

                        if (self.desserts.length>0)
                        {                    



                                this.registrando=true;

                                self.desserts.forEach(element => {

                                        if(element.devuelta > 0)
                                        {

                                                vMatDev.push({
                                                ot: self.vOtrabajo,
                                                nombreot : self.vDetalle,
                                                usuario : this.$store.state.nombre,
                                                item : element.item,
                                                codigo: element.articulo == "" || element.articulo == null ? "" :  element.articulo,
                                                detalle: element.detalle == "" || element.detalle == null ? "" :  element.detalle,
                                                pedido: element.pedido == "" || element.pedido == null ? 0 :  element.pedido.toString().replace(',', '.'),
                                                devuelto: element.devuelta == "" || element.devuelta == null ? 0 :  element.devuelta.toString().replace(',', '.'),
                                                iitem : element.item,
                                                observa : self.vObserva,
                                                estado: 1,
                                                activo:1,
                                            })


                                        }                                   
                                        

                                });

                               console.log("datosss", vMatDev)
                                 let  Soli = {

                                    
                                        MaterialDevuelto: vMatDev
                                        
                                }


                                Axios
                                .post("/App/RegistrarDevolucionMaterial", Soli)                                                    
                                .then((response) => 
                                {

                                        
                                        
                                        console.log("lo que me devuelve guardar", response.data)
                                        this.vNroComprobante = response.data;
                                    

                                    
                                        this.vRegistrar=true;

                                        this.desserts = [];

                                        this.mostrarDetalleOT(this.vOtrabajo);
                                     

                                        this.registrando=false;

                                        this.$swal({
                                        title: "",
                                        text: "Se registro con éxito la devolución de material, N° de comprobante es: " +  this.vNroComprobante,
                                        icon: "success"
                                        });



                                })

                                    

                                .catch((error) => {                            
                                        console.log(error);


                                });   
                                    
                            


                          
                            }       

                    }

                });



              

            },

            irMenuInge(){

                this.$router.push({ name: 'MenuInge' });

            },

            validarDevuelta(item) {
                if (item.devuelta > item.pedido) {
                this.$swal({
                    icon: 'warning',
                    title: 'Cantidad inválida',
                    text: 'La cantidad devuelta no puede ser mayor a la cantidad solicitada.',
                    confirmButtonText: 'Aceptar'
                })

                item.devuelta = 0;
                }

                if (item.devuelta < 0) {
                item.devuelta = 0;
                }
            },

            mostrarBuscadorOt(){

                this.numOT = "";
                this.nombreOT = "";            
                this.showCarga = true
         
                if (this.$store.state.ot_sel != "") {
                   
                  
                    this.mostrarCabeceraOT(this.vOtrabajo);
                }

            },


            showAlert(alertInfo) {
                alertInfo.vm.$swal.fire({
                    icon: alertInfo.icon,
                    title: alertInfo.title,
                    showConfirmButton: false,
                    background: "#ececec",
                    timer: 2000,
                });
            },


            activar(item){

                console.log("estoy en activar",item)

                let self = this; 

                self.dessertsDevo=[];

                Axios               
                // .get("/SolicitudEI026/DetalleOT?", {
                .get("/Ti/MostrarDevolcion?", {
                params: {
                    id: this.vOtrabajo,
                    id1: item.item
                },
                })
                .then(r => {                 

                    console.log("datos base de datos", r.data)

                    if (r.data.length == 0){
                         this.$swal("","No existen datos para la orden de trabajo ingresada", "info")
                    }


                    r.data.forEach(element => {
                        self.dessertsDevo.push({

                            fecha: element.fecha
                            ? moment(element.fecha).format('DD/MM/YYYY')
                            : '',
                            comprobante : element.comprobante,
                            detalle: element.detalle,
                            item: element.item,
                            articulo: element.articulo,
                            detalle: element.detalle,
                            devuelto: element.devuelto,                           
                        
                            
                        })
                    });
                     
                  
                    this.vDialogDevolucion=true;    


                }).catch(r => {        
                     
                       this.$swal("","La orden de trabajo ingresada esta vacia", "info")
                });  


    

            },






    }


      

     



    
}
</script>

